module.exports = __webpack_public_path__ + "static/img/value-icon03-01_blue.f16f4d1e.png";